export default __webpack_public_path__ + "static/media/图标.1e084282.jpg";